<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item   prop="value" label="VALUE">
                        <el-input  type="textarea" :rows="2" v-model="form.value" maxlength="1000"></el-input>
                    </el-form-item>

                    <el-form-item   prop="remark" label="备注">
                        <el-input  type="textarea" :rows="2" v-model="form.remark" maxlength="200"></el-input>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="200" type="number"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" :loading="loading" @click="save()">确定</el-button>
            </span>    
        </el-dialog>

    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import { Base64 } from 'js-base64'

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    value:"",
                    remark:"",
                    orderNum:1
                },
                rules: {
                    value: [
                        { required: true, message: '请输入VALUE', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
            init(type,data){
                this.visible=true;
                this.form.id=data.id;
                this.form.name=data.text;
                this.form.value=data.attributes.value;
                this.form.remark=data.attributes.remark;
                this.form.orderNum=data.attributes.orderNum;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading = true
                        let url= this.dictUpdateUrl;
                        let data = {
                            id:this.form.id,
                            value:Base64.encode(this.form.value),
                            remark:(this.form.remark==''?'':Base64.encode(this.form.remark)),
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading = false
                        }, (err) => {
                            console.log(err);
                            this.loading = false
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dict/Update.vue